import React, {useState} from 'react';
import {extract,toStyle} from "../utils";
import {Carousel as PRCarousel} from "primereact/carousel";

import _ from 'lodash';
export const Carousel = ({env = 'form',value, render, activeIndex= null, onPageChange = undefined, extraConfig, ...rest}) => {
    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];
    const {showEmpty = false, skipOnSingle = true, emptyMsg = ''} = extraConfig
    const useValue = _.flattenDeep(value || []).filter( el => showEmpty || !!el)
    console.log('CAROUSEL VIEWER', useValue, value)
    if(skipOnSingle && useValue.length <2){
        return useValue.length ? render(useValue[0]) : emptyMsg
    }
    return (
        <PRCarousel value={useValue} itemTemplate={item => render(item)} page={activeIndex} onPageChange={onPageChange ? (e) => onPageChange(e.page) : null}
                    style={toStyle(_.get(extraConfig,'style'), {maxHeight: '100%'})}
                    {...extract( {numVisible: 1, numScroll: 1, header: undefined, footer: undefined,  className: undefined,
                  circular: undefined, autoplayInterval: undefined, transitionInterval: undefined, responsiveOptions: undefined,showIndicators:false,
                      orientation: undefined, verticalViewPortHeight: undefined, contentClassName: undefined, containerClassName: undefined, indicatorsContentClassName: undefined,
                  }, extraConfig)}/>
    )
}